import { render, staticRenderFns } from "./form-checkbox.vue?vue&type=template&id=cf4ff0c2&scoped=true&"
import script from "./form-checkbox.vue?vue&type=script&lang=js&"
export * from "./form-checkbox.vue?vue&type=script&lang=js&"
import style0 from "./form-checkbox.vue?vue&type=style&index=0&id=cf4ff0c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf4ff0c2",
  null
  
)

export default component.exports